import { useContext } from 'react';

import {
  DragDropContext,
  type IDragDropContextData,
} from '../contexts/dragDrop';

export const useDragDrop = (): IDragDropContextData =>
  useContext(DragDropContext);
